import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bcb30822"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode(" 可配置规则为： "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 1.域名: example.com "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 2.通配符域名: *.example.com, *ple.com "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 3.ip: 114.114.114.114 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 4.网段：192.168.1.0/24 ")
], -1))

import { onMounted, ref, shallowRef, watch } from 'vue';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import { ScForm } from '@/models/ScForm';
import { JSONFieldType } from '@/components/business/crud/interface/FieldType';
import * as monaco from 'monaco-editor';
import { monacoHolder } from '@/util/monaco';


export default /*#__PURE__*/_defineComponent({
  __name: 'RuleForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();
const containerRef = ref<HTMLElement>();
const editRef = ref<HTMLElement>();
const viewRef = ref<HTMLElement>();
const editor = shallowRef<monaco.editor.IStandaloneCodeEditor>();
const viewer = shallowRef<monaco.editor.IStandaloneCodeEditor>();

onMounted(() => {
  if (editRef.value) {
    const resizeObserver = new ResizeObserver(() => {
      if (editor.value) {
        editor.value.layout();
      }
    });
    resizeObserver.observe(editRef.value);
  }
  if (viewRef.value) {
    const resizeObserver = new ResizeObserver(() => {
      if (viewer.value) {
        viewer.value.layout();
      }
    });
    resizeObserver.observe(viewRef.value);
  }
});

watch([editRef], () => {
  if (editor.value) {
    editor.value.dispose();
  }
  if (!editRef.value) {
    return;
  }
  editor.value = monacoHolder.value.editor.create(editRef.value, {
    value: data.value[props.propName],
    language: 'plaintext',
    theme: 'vs-dark',
    minimap: {
      enabled: false,
    },
    readOnly: props.info.status === 'show',
  });
  check();
  editor.value.onDidChangeModelContent(check);
});

function check() {
  if (!editor.value) {
    return;
  }
  const model = editor.value.getModel();
  if (!model) {
    return;
  }
  const markers: monaco.editor.IMarkerData[] = [];
  const lines = model.getLinesContent();
  lines.forEach((lineContent, lineNumber) => {
    if (isInvalid(lineContent)) {
      markers.push({
        startLineNumber: lineNumber + 1,
        startColumn: 1,
        endLineNumber: lineNumber + 1,
        endColumn: lineContent.length + 1,
        message:
          '规则格式不正确\n必须是以下几种格式之一。ip地址如1.2.3.4, 网段如1.2.3.4/8, 域名如example.com或通配符域名如*.exa*.com ',
        severity: monaco.MarkerSeverity.Error,
      });
    }
  });
  monacoHolder.value.editor.setModelMarkers(
    model,
    'plaintext-validation',
    markers
  );
  data.value[props.propName] = editor.value.getValue();
}

const ipv4Reg =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\/[0-9]{1,2})?$/;
const ipv6Reg = /^([0-9a-fA-F]{1,4}:){7}([0-9a-fA-F]{1,4})(\/[0-9]{1,3})?$/;
const hostReg = /^([a-zA-Z0-9*-]+\.)+[a-zA-Z*]+$/;

function isInvalid(content: string) {
  return (
    content !== '' &&
    !ipv4Reg.test(content) &&
    !ipv6Reg.test(content) &&
    !hostReg.test(content)
  );
}

watch(
  () => data.value[props.propName],
  (value) => {
    if (editor.value && editor.value.getValue() !== value) {
      editor.value.setValue(value);
    }
  }
);

watch(
  () => props.info.status,
  (value) => {
    if (editor.value) {
      editor.value.updateOptions({
        readOnly: value === 'show',
      });
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "editor-container",
      style: {"padding":"0 16px"},
      ref_key: "containerRef",
      ref: containerRef
    }, [
      _createElementVNode("div", {
        ref_key: "editRef",
        ref: editRef,
        style: {"width":"80%","height":"400px"}
      }, null, 512)
    ], 512)
  ]))
}
}

})